import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const updateUpdatedProductKey = 'updateUpdatedProduct';

export interface UpdateUpdatedProductState {
  updateUpdatedProductResponse: any;
  updateUpdatedProductFailure: any;
  loaded: boolean;
}

export const initialState: UpdateUpdatedProductState = {
  updateUpdatedProductResponse: undefined,
  updateUpdatedProductFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.updateUpdatedProductSuccess, (state, action) => ({
    ...state,
    updateUpdatedProductResponse: action.response,
    loaded: true
  })),

  on(actions.updateUpdatedProductFailure, (state, action) => ({
    ...state,
    updateUpdatedProductFailure: action.error
  }))
);

export const updateUpdatedProduct = (state: UpdateUpdatedProductState) => state.updateUpdatedProductResponse;
